import axiosConfig from "./axiosConfig";
import { PeopleRole } from "../models/peopleCandidate";

export interface PeopleSelectionResponse {
  role: PeopleRole;
  selectedCount: number;
}

// Persist the operator's picked people for a role (the durable shortlist step 7
// consumes). No cap on how many can be picked.
const patchLeadPeopleSelection = async (
  authToken: string,
  leadId: string,
  role: PeopleRole,
  selectedApolloIds: string[]
): Promise<PeopleSelectionResponse> => {
  const { data } = await axiosConfig.patch(
    `/leads/${leadId}/people-selection`,
    { role, selectedApolloIds },
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default patchLeadPeopleSelection;
